module.exports = __webpack_public_path__ + "static/media/SY.7c5c07e2.png";